export default __webpack_public_path__ + "static/media/spgroup-favicon.cfb9f407.ico";